import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { styles } from './ControlOptions.styles';
import { EShowHeaderFooter } from '@opengov/stories-shared/constants';
import { ISetupPdfMessages } from '../../../../../../types/setupPDFTypes';

export const ControlOptions = ({
  type,
  messages,
  selectedOption,
  handleOptionChange
}: {
  type: 'header' | 'footer';
  messages: ISetupPdfMessages;
  selectedOption: EShowHeaderFooter;
  handleOptionChange: (option: EShowHeaderFooter) => void;
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    handleOptionChange(event.target.value as EShowHeaderFooter);
  };

  const isHeader = type === 'header';
  return (
    <>
      <Box>
        <Typography sx={styles.storyFooterTitle}>
          {isHeader ? messages.controlHeaderTitle : messages.controlFooterTitle}
        </Typography>
        <Typography sx={styles.storyFooterDescription}>
          {isHeader ? messages.controlHeaderDescription : messages.controlFooterDescription}
        </Typography>
      </Box>
      <RadioGroup
        aria-labelledby={`${type}-options-radio-buttons-group-label`}
        name={`${type}-options-radio-buttons-group`}
        value={selectedOption}
        onChange={handleChange}
      >
        <FormControlLabel
          value={EShowHeaderFooter.All}
          control={<Radio inputProps={styles.controls} />}
          label={messages.allStory}
        />
        <FormControlLabel
          value={EShowHeaderFooter.First}
          control={<Radio inputProps={styles.controls} />}
          label={messages.firstStory}
        />
        <FormControlLabel
          value={EShowHeaderFooter.Last}
          control={<Radio inputProps={styles.controls} />}
          label={messages.lastStory}
        />

        <FormControlLabel
          value={EShowHeaderFooter.Both}
          control={<Radio inputProps={styles.controls} />}
          label={messages.bothStory}
        />

        <FormControlLabel
          value={EShowHeaderFooter.None}
          control={<Radio inputProps={styles.controls} />}
          label={messages.noStory}
        />
      </RadioGroup>
    </>
  );
};
